// Usage:
// <textarea v-autosize></textarea>

import autosize from 'autosize';

export default {
    install(Vue, options) {
        Vue.directive('autosize', this);
    },
    bind(el) {
        autosize(el);
    },
    inserted(el) {
        autosize.update(el);
    },
    update(el) {
        autosize.update(el);
    },
    unbind(el) {
        autosize.destroy(el);
    },
}
